import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';

const ProductCatalog = () => {
  const { categoria } = useParams();
  const location = useLocation();
  const [allProducts, setAllProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [banners, setBanners] = useState([]);
  const [subcategorys, setSubCategorys] = useState([]);
  const isMobile = window.innerWidth <= 768;
  const postApi = "https://ryc-soluciones-nicaragua.com/api/index.php";
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('Camaras Vehiculos');


  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("search");

  const fetchProducts = async () => {
    try {
      let url = `${postApi}?getAllProductsCam=true`;
      if (categoria) {
        setSelectedCategory(categoria.replaceAll("-", " "));

        url = `${postApi}?getAllProductsByCategory=true&category=${categoria.replaceAll("-", " ")}`;
        setSelectedFilters([]);
        setShowFilters(false);
      } else if (searchQuery) {
        setSelectedCategory("");
        url = `${postApi}?searchProduct=true&query=${encodeURIComponent(searchQuery)}`;
      }

      const response = await axios.get(url);
      setProducts(response.data);
      setAllProducts(response.data);
    } catch (error) {
      console.error("Error al obtener productos:", error);
    }
  };

  // Obtener productos desde la API
  useEffect(() => {
    
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${postApi}?getAllBanners=true`);
        setBanners(response.data);
      } catch (error) {
        console.error("Error al obtener banners:", error);
      }
    };

    const fetchSubCategorys = async () => {
      try {
        const categoriaFinal = categoria?.trim()
      ? categoria.replaceAll("-", " ")
      : "Camaras Vehiculos";
        const response = await axios.get(`${postApi}?getAllsubcategory=true&category=${categoriaFinal.replaceAll("-", " ")}`);
        setSubCategorys(response.data);
      } catch (error) {
        console.error("Error al obtener banners:", error);
      }
    };

    fetchBanners();
    fetchProducts();
    fetchSubCategorys();
  }, [categoria, searchQuery]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [banners]);

  const handleFilterChange = (category, keyword) => {
    setSelectedFilters(prev => {
      const existingCategory = prev.find(item => item.category === category);
      if (existingCategory) {
        // Si ya existe la categoría, añadir o quitar keyword
        const keywordExists = existingCategory.keywords.includes(keyword);
        const newKeywords = keywordExists
          ? existingCategory.keywords.filter(k => k !== keyword)
          : [...existingCategory.keywords, keyword];

        // Si no quedan keywords, quitar toda la categoría
        if (newKeywords.length === 0) {
          return prev.filter(item => item.category !== category);
        }

        return prev.map(item =>
          item.category === category ? { ...item, keywords: newKeywords } : item
        );
      } else {
        // Si no existe la categoría, agregarla
        return [...prev, { category, keywords: [keyword] }];
      }
    });
  };

  const applyFilters = async () => {

  if (selectedFilters.length === 0) {
    console.log("No hay filtros seleccionados, no se hace petición.");
    return;
  }

  try {
    
    const filtersPayload = JSON.stringify(selectedFilters);

    console.log("Filtros enviados al PHP:", filtersPayload);
    setProducts([]);
    const url = `${postApi}?getProductsByFilter=true&filters=${encodeURIComponent(filtersPayload)}`;
    const response = await axios.get(url);
    setProducts(response.data);
    setShowFilters(false);

  } catch (error) {
    console.error("Error aplicando filtro:", error);
  }
};


  const clearFilters = () => {
    setSelectedFilters([]);
    fetchProducts();
    setShowFilters(false);
  };

  return (
    <div className="container mt-4">

     {/* Banner */}
      {banners.length > 0 && (
        <div
          className="banner d-flex flex-column flex-md-row align-items-center justify-content-center mb-5 mb-md-0"
          style={{
            width: "100%",
            backgroundColor: "#f0f0f0",
            borderRadius: "8px",
            transition: "opacity 0.5s ease-in-out",
          }}
        >
          <img
            src={isMobile ? banners[currentBannerIndex].image_url_mobile : banners[currentBannerIndex].image_url_desktop}
            alt="Banner"
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>
      )}

      {/* Botón para abrir filtros */}
      {/* {subcategorys.some(sub => sub.category_name === selectedCategory) && ( */}
        <button className="btn btn-primary mb-3" onClick={() => setShowFilters(true)}>
          <i className="fas fa-filter"></i> Filtros
        </button>
      {/* )} */}

      {/* Modal de filtros */}
      {showFilters && (
        <div className="modal fade show" style={{ display: "block" }} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Filtrar por Palabras Clave</h5>
                <button type="button" className="btn-close" onClick={() => setShowFilters(false)} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                {/* Recorrer subcategorías y mostrar keywords */}
                {subcategorys.map((sub, index) => (
                  <div key={index}>
                    <strong>{sub.category_name}</strong>
                    {sub.keywords.map((keyword, i) => (
                      <div key={i} className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`filter-${index}-${i}`}
                          checked={selectedFilters.some(f => f.category === sub.category_name && f.keywords.includes(keyword))}
                          onChange={() => handleFilterChange(sub.category_name, keyword)}
                        />
                        <label className="form-check-label" htmlFor={`filter-${index}-${i}`}>
                          {keyword}
                        </label>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={applyFilters}>Aplicar Filtro</button>
                <button type="button" className="btn btn-danger" onClick={clearFilters}>Borrar Filtros</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <h2 className="text-center mb-4">{categoria ? `Categoría: ${categoria}` : "Todos los productos"}</h2> */}
      <div className="row">
        {products.map((product) => (
          <div className="col-md-4 mb-4" key={product.id}>
            <div
              className="card shadow-lg border-1 rounded-3 overflow-hidden position-relative d-flex flex-column h-100 p-3"
              style={{
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 8px 15px rgba(0, 0, 0, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div className="mb-1 is-size-10 is-size-9 text-uppercase fw-bold" style={{ color: "#00377b" }}>{product.code}</div>
              {/* Contenedor Flex para Imagen e Información */}
              <div className="d-flex flex-row align-items-center">
                {/* Imagen a la izquierda */}
                <div className="flex-shrink-0 text-center">
                  <img
                    src={product.image}
                    className="img-fluid"
                    alt={product.name}
                    style={{
                      maxHeight: "150px",
                      maxWidth: "150px",
                      objectFit: "contain",
                      marginBottom: "10px",
                    }}
                  />
                </div>
                {/* Información a la derecha */}
                <div className="flex-grow-1 ms-3 p-2">
                  <h6 className="mb-2 is-size-5" style={{ color: "#00377b" }}>
                    {product.name}
                  </h6>
                  {/* <p className="mb-1 is-size-10">Precio:</p> */}
                  <p className="fs-5 mb-0 is-size-6" style={{ color: "#00377b" }}>
                    <span
                      style={{
                        textDecoration: product.on_clearance === 1 ? "line-through" : "none",
                      }}
                    >
                      {product.currency}{" "}
                      {parseFloat(product.price).toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })}
                    </span>

                    {product.on_clearance === 1 && (
                      <span
                        style={{
                          display: "block",
                          color: "red",
                          fontSize: "1em",
                          fontWeight: "bold",
                          marginTop: "0.2em",
                        }}
                      >
                        {product.currency}{" "}
                        {parseFloat(product.clearance_price).toLocaleString("en-US", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                      </span>
                    )}
                  </p>

                </div>
              </div>

              {/* Botón "Ver más" debajo de la imagen */}
              <div className="d-flex justify-content-center mt-auto">
                <button
                  className="btn btn-sm text-white w-50"
                  onClick={() => navigate(`/producto/${product.id}`)}
                  style={{
                    backgroundColor: "#00b5e2",
                    padding: "8px 12px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  Ver detalles
                </button>
              </div>

              {/* Botón de WhatsApp */}
              <a
                className="btn btn-success position-absolute bottom-0 end-0 m-2 rounded-circle p-2 d-flex align-items-center justify-content-center"
                style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.3)", fontSize: "24px" }}
                href={(() => {
                  const phone = "50577005446";
                  const text = `Hola+estoy+interesado+en+este+producto:%0D%0A%0D%0A*${encodeURIComponent(product.name)}*%0A*Precio:*%20${encodeURIComponent(product.price)}%0A*URL:*%20https%3A%2F%2Fryc-soluciones-nicaragua.com%2Fproducto%2F${encodeURIComponent(product.id)}`;

                  // Detectar si el usuario está en móvil
                  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

                  return isMobile
                    ? `https://wa.me/${phone}?text=${text}`
                    : `https://web.whatsapp.com/send?phone=${phone}&text=${text}`;
                })()}
                title={`Hablar sobre ${product.name} en WhatsApp`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp" style={{ fontSize: "24px", color: "white" }}></i>
              </a>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductCatalog;
